import { render, staticRenderFns } from "./FacebookMediaTemplate.vue?vue&type=template&id=e64d57d8&scoped=true&"
import script from "./FacebookMediaTemplate.vue?vue&type=script&lang=js&"
export * from "./FacebookMediaTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FacebookMediaTemplate.vue?vue&type=style&index=0&id=e64d57d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d57d8",
  null
  
)

export default component.exports